// import { compose, createStore } from 'redux';
// import combinedReducers from './reducers/combined-reducers';
//
// // @ts-ignore
// const reduxDevtoolsExtension = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__;
//
// const composeEnhancers =
//   process.env.NODE_ENV !== 'production' && reduxDevtoolsExtension
//     ? reduxDevtoolsExtension
//     : compose;
//
// const store: any = createStore(combinedReducers, composeEnhancers());
//
// export default store;

import { configureStore } from '@reduxjs/toolkit';
import combinedReducers from './reducers/combined-reducers';

const store = configureStore({
  reducer: combinedReducers,
});

export type RootState = ReturnType<typeof combinedReducers>;
export default store;
